import { IVehicleTypeInitialState } from "../../../types/master/vehicleTypeInterface";
import { VehicleTypeActionTypes, VehicleTypeActions } from "../../actionTypes/master/vehicleTypeActionTypes";

const initialState: IVehicleTypeInitialState = {
  vehicleTypeList: [],
  vehicleTypeData: {
    id: 0,
    manufacturer_name: "",
    model_name: "",
    body_type: "",
    fuel_type: "",
    gross_weight: 0,
    unladen_capacity: 0,
    total_cylinders: 0,
    wheel_base: 0,
    fuel_capacity: 0,
    load_capacity: 0,
    total_tyre: 0,
  },
  vehicleTypeListPageCount: 0,
};

// prettier-ignore
export default function vehicleTypeReducer(state = initialState, action: VehicleTypeActionTypes): IVehicleTypeInitialState {
  switch (action.type) {
    case VehicleTypeActions.SET_VEHICLE_TYPE_LIST:
      return {
        ...state,
        vehicleTypeList: action.payload,
      };

    case VehicleTypeActions.SET_VEHICLE_TYPE_LIST_PAGE_COUNT:
      return {
        ...state,
        vehicleTypeListPageCount: action.payload,
      };

    case VehicleTypeActions.SET_VEHICLE_TYPE_DATA_BY_ID:
      return {
        ...state,
        vehicleTypeData: action.payload,
      };

    default:
      return state;
  }
}
